import * as React from "react";
// import "../styles/pages/sale.scss"
import styles from "../styles/pages/sale.module.scss";
import { withRouter } from "next/router";
import { IProduct, ISale } from "../types/sale";
import { formatPublicHome, formatNextHome, transformImage } from "../utils";
import MetaHeader from "../components/meta-header/meta-header";
import {
  transformPriceToNumber,
  transformPrice as transformPriceWithCurrency,
} from "../api/currency";
import nextI18NextConfig from "../next-i18next.config.js";
import FooterNewComponent from "../new-components/footer/Footer";
import { HeaderNewComponent } from "../new-components/header/Header";
import AppNewComponent from "../new-components/sale/App/App";
import KeysNewComponent from "../new-components/home/Keys/Keys";
import {
  ProductCarouselComponent,
  ModalImageComponent,
} from "../components/external";
import LazyProductImage from "../components/lazy-product-image/lazy-product-image";
import { withTranslation } from "next-i18next";
import { canonical } from "../config";
import { getLang } from "../utils/lang";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { catalogApi } from "../api/catalog";
const extraData = {} as any;
class ProductScreen extends React.Component<
  {
    router: any;
    t: any;
    sale?: ISale;
    i18n?: any;
    product?: IProduct;
    store: "fr" | "us";
  },
  {}
> {
  get getTitle() {
    if (this.props.product && this.props.sale) {
      return `${this.props.sale?.name} - ${
        this.props.product.subtitle
      } | ${this.getTrad("sale_ongoing")}`;
    }
    return ``;
  }

  get getDescription() {
    if (this.props.sale?.sale_ended) {
      return `${this.props.sale?.name} - ${
        this.props.product.subtitle
      } ${this.getTrad("discover")}. ${this.getTrad("sale_delivery")}`;
    } else if (this.props.sale?.sale_started) {
      return `${this.props.sale?.name} - ${
        this.props.product.subtitle
      } ${this.getTrad("discover")} ${this.getTrad("basic")} ${formatPublicHome(
        this.props.sale?.end_at,
        getLang(this.props.i18n),
        this.props.sale?.store || "fr"
      )}. ${this.getTrad("sale_delivery")}`;
    }
    return `${this.props.sale?.name} - ${
      this.props.product.subtitle
    } ${this.getTrad("discover")} ${this.getTrad("basic")} ${formatNextHome(
      this.props.sale?.start_at,
      this.props.sale?.end_at,
      getLang(this.props.i18n),
      this.props.sale.store
    )}. ${this.getTrad("sale_delivery")}`;
  }

  get getMainImage() {
    if (
      this.props.product &&
      Array.isArray(this.props.product.images) &&
      this.props.product.images[0]
    ) {
      return transformImage(this.props.product.images[0].url, "750");
      // return `https://img.appchoose.io/unsafe/630x630/filters:watermark(https://public.choose.app/website/new/images/logo-${
      //   this.props.product.images[0].dark_color ? "white" : "black"
      // }.png,158,272,50)/prod/${
      //   this.props.product.images[0].url.split("/prod/")[1]
      // }`;
    }
  }

  get isAvailable() {
    if (this.props.sale) {
      return (
        !this.props.sale?.sale_ended &&
        this.props.sale?.sale_started &&
        !this.props.product.tester
      );
    }
    return undefined;
  }

  get getAppleMeta() {
    if (this.props.product) {
      if (!this.props.sale?.single_offer && this.props.sale?.url) {
        return `chooseapp://sales/${encodeURIComponent(this.props.sale?.url)}`;
      }
      return `chooseapp://product/${encodeURIComponent(
        this.props.product.url
      )}`;
    }
  }

  get getAvailability() {
    if (this.props.sale) {
      if (this.props.sale?.sale_ended) {
        return "https://schema.org/Discontinued";
      } else if (this.props.sale?.sale_started) {
        return this.props.product.stock !== 0
          ? "http://schema.org/InStock"
          : "http://schema.org/OutOfStock";
      }
    }
    return "https://schema.org/PreOrder";
  }

  get getGender() {
    if (this.props.product) {
      if (this.props.product.gender === 0) {
        return "female";
      } else if (this.props.product.gender === 1) {
        return "male";
      }
      return "unisex";
    }
    return "unisex";
  }

  get setSchema() {
    return {
      __html: this.props.product
        ? `{"@context": "http://schema.org",
                "@type": "Product",
                "gender": "${this.getGender}",
                "age_group":"adult",
                "offers": {
                  "@type": "Offer",
                  "itemCondition": "https://schema.org/NewCondition",
                  "availability": "https://schema.org/InStock",
                  "price":  ${transformPriceToNumber(
                    this.props.product.formatted_price as number
                  )},
                  "priceCurrency": "${this.props.product.currency.toUpperCase()}"
                  },
                  "description": "${this.props.product.description
                    .replace(/<b>/g, "")
                    .replace(/<\/b>/g, "")
                    .replace(/"/g, "")
                    .replace(/(\r\n|\n|\r)/gm, " ")}",
                  "name": "${this.props.product.subtitle
                    .replace(/"/g, "")
                    .replace(/(\r\n|\n|\r)/gm, " ")}",
                  "brand":"${(
                    this.props.product.brand_name || this.props.product.title
                  )
                    .replace(/"/g, "")
                    .replace(/(\r\n|\n|\r)/gm, " ")}",
                  "gtin":"${this.props.product.gtin || ""}",

                    "image":"${this.getMainImage}",
                 
                  "url": "${canonical}product/${encodeURIComponent(
            this.props.product.url
          )}"
            }`.replace(/\n/g, "")
        : "",
    };
  }

  get getText() {
    if (this.props.sale?.sale_ended) {
      return this.getTrad("sale_ended");
    } else if (this.props.sale?.sale_started) {
      return `${this.getTrad("sale_ongoing")} ${formatPublicHome(
        this.props.sale?.end_at,
        getLang(this.props.i18n),
        this.props.sale.store
      )}`;
    }
    return `${this.getTrad("sale_next")} ${formatNextHome(
      this.props.sale?.start_at,
      this.props.sale?.end_at,
      getLang(this.props.i18n),
      this.props.sale.store
    )}`;
  }

  public state: {
    selectedImageId: number;
    displayModal: boolean;
  } = {
    selectedImageId: 0,
    displayModal: false,
  };
  public getTrad = (str: string) => {
    return this.props.t(str);
  };

  public onModalClick = () => {
    this.setState({ displayModal: !this.state.displayModal });
  };

  public onImageSelect = (selectedImageId: number) => {
    this.setState({ selectedImageId });
  };

  // tslint:disable-next-line:cognitive-complexity
  public render() {
    if (this.props.sale) {
      extraData.saleId = this.props.sale?.key;
      extraData.itemId = this.props.product.key;
    }
    return (
      <div className={styles.sale}>
        <MetaHeader
          pageTitle={this.getTitle}
          canonical={
            canonical + "product/" + encodeURIComponent(this.props.product.url)
          }
          keywords={
            this.props.product.subtitle + "," + this.props.product.brand_name
          }
          appleArguments={this.getAppleMeta}
          isSquare={true}
          description={this.getDescription
            .replace(/<b>/g, "")
            .replace(/<\/b>/g, "")}
          title={this.getTitle}
          image={this.getMainImage}
          noIndex={true}
        />

        <HeaderNewComponent
          showSlogan={true}
          disableScroll={true}
          hideBtns={true}
          store={this.props.store}
          language={this.props.i18n.language}
        />
        <div className="container align-items-center">
          <div className={`row ${styles.sale_data} ${styles.product_data}`}>
            {!this.state.displayModal ? null : (
              <ModalImageComponent
                images={this.props.product.images.map((c) => c.url)}
                focusOn={this.state.selectedImageId}
                onClose={this.onModalClick}
              />
            )}
            <ProductCarouselComponent
              images={this.props.product.images.slice(0, 4)}
              onClickModal={this.onModalClick}
              className={styles.carousel}
              onSelect={this.onImageSelect}
              idxSelected={this.state.selectedImageId}
            />

            <div className={`col-sm-0 col-1 col-md-2 ${styles.separation}`} />
            <div className={`col-4 col-md-8 col-sm-12 ${styles.sale_info}`}>
              <h1 className={styles.title_brand}>
                {this.props.product.title || this.props.product.brand_name}
              </h1>
              <p className={styles.title_product}>
                {this.props.product.subtitle}
              </p>
              {this.props.sale?.badges ? (
                <div className={styles.badges}>
                  {this.props.sale?.badges.map((badge) => {
                    return (
                      <div className={styles.badge} key={badge.text}>
                        <LazyProductImage
                          height="16"
                          width="16"
                          disableWebp={true}
                          src={badge.image}
                          alt={badge.text}
                        />
                        <p>{this.props.t(badge.code)}</p>
                      </div>
                    );
                  })}
                </div>
              ) : null}
              <div className={styles.pricesproduct}>
                <p className={styles.price_formatted}>
                  {transformPriceWithCurrency(
                    this.props.product.formatted_price as number,
                    this.props.i18n.language || "fr",
                    this.props.product.currency
                  )}
                  {/* {this.props.product.formatted_price} */}
                </p>
                {this.props.product.price !==
                this.props.product.formatted_price ? (
                  <>
                    <p className={styles.price_normal}>
                      {transformPriceWithCurrency(
                        this.props.product.price,
                        this.props.i18n.language || "fr",
                        this.props.product.currency
                      )}
                    </p>
                    <p className={styles.discount}>
                      -{this.props.product.discount}%
                    </p>
                  </>
                ) : null}
              </div>
              {this.props.product.eee_price ? (
                <p className={styles.price_normal_eee}>
                  {this.props.t("ecopart")}{" "}
                  <b>
                    {transformPriceWithCurrency(
                      this.props.product.eee_price,
                      this.props.i18n.language,
                      this.props.product.currency
                    )}
                  </b>
                </p>
              ) : null}
              <p
                className={styles.date}
                dangerouslySetInnerHTML={{ __html: this.getText }}
              />
              <AppNewComponent className={styles.app} />
            </div>
            <div className={`col-sm-0 col-1 col-md-2 ${styles.separation}`} />
          </div>

          <hr className={styles.sale_hr} />
        </div>
        <KeysNewComponent />
        <FooterNewComponent store={this.props.store} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={this.setSchema}
        />
      </div>
    );
  }
}

export const getServerSideProps = async (props) => {
  const tmp = {
    props: {
      ...(await serverSideTranslations(
        props.query.language ||
          props.query.lang ||
          props.locale ||
          props.defaultLocale ||
          "fr",
        ["common", "keys", "sale"],
        nextI18NextConfig as any
      )),
      ...props.query,
      store: props.query.store || "fr",
    },
  } as any;
  try {
    let product = {} as IProduct;
    let sale = {} as ISale;
    const [id] =
      props.query && props.query.id ? props.query.id.split("@v=") : [];
    // FROM SERVER
    const variant_id = props.query.variant;

    const resProduct = await catalogApi.getProduct(
      id,
      variant_id,
      props.query.store
    );

    if (resProduct) {
      const saleId = resProduct?.sale_id;
      sale = await catalogApi.getSale(saleId, props.query.store);
      product = resProduct;
    } else {
      return {
        redirect: {
          destination: "/error?from=product&id=" + id,
          permanent: false,
        },
      };
    }
    tmp.props.sale = sale;
    // isServerRendered: !!req,
    tmp.props.product = product;
    tmp.props.userAgent = props.query ? props.query.ua : {};
    tmp.props.store = props.query.store || "fr";
    // }

    // } else {
    //     return {
    //         redirect: {
    //             destination: '/error',
    //             permanent: false,
    //         },
    //     }
    // }
  } catch (error) {
    tmp.props.error = error;
    tmp.props.sale = {};
    tmp.props.isServerRendered = !!props.req;
    tmp.props.userAgent = props.query ? props.query.ua : {};
    tmp.props.store = props.query.store || "fr";
  }

  return tmp;
};

export default withTranslation("sale")(withRouter(ProductScreen) as any);
